import type { CompetencyMatrixReport, CompetencyMatrixReportParams } from '@/types/reports';

import { api } from '@/api/api';

export default {
    async getCompetencyMatrix(
        params: CompetencyMatrixReportParams,
    ): Promise<CompetencyMatrixReport> {
        const response = await api.get('/Report/competency-matrix', { params });
        return response.data;
    },
};
